/**
 * The carrier that moves a Virtual drop-off from the hub to the merchant. Values
 * double as Virtual's dash code `third_party_carrier`.
 */
export const VirtualMiddleMileCarrier = {
  UNIUNI: "UNIUNI",
  RETURN_DROP: "RETURN_DROP",
} as const;
export type VirtualMiddleMileCarrier =
  (typeof VirtualMiddleMileCarrier)[keyof typeof VirtualMiddleMileCarrier];

/** Whether the hub verifies the items (verified) or just accepts a packaged parcel. */
export const VirtualServiceLevel = {
  VERIFIED: "VERIFIED",
  UNVERIFIED: "UNVERIFIED",
} as const;
export type VirtualServiceLevel =
  (typeof VirtualServiceLevel)[keyof typeof VirtualServiceLevel];

/** Entries stored before carriers were recorded are UniUni. */
export function virtualMiddleMileCarrierOf(metadata: {
  carrier?: VirtualMiddleMileCarrier | null;
}): VirtualMiddleMileCarrier {
  return metadata.carrier ?? VirtualMiddleMileCarrier.UNIUNI;
}

/** Entries stored before service levels were recorded are verified. */
export function virtualServiceLevelOf(metadata: {
  serviceLevel?: VirtualServiceLevel | null;
}): VirtualServiceLevel {
  return metadata.serviceLevel ?? VirtualServiceLevel.VERIFIED;
}

const virtualMiddleMileCarrierNames: Record<VirtualMiddleMileCarrier, string> =
  { UNIUNI: "UniUni", RETURN_DROP: "Return Drop" };

/** Carrier name reported to integrations alongside the tracking number. */
export function getVirtualMiddleMileCarrierName(
  carrier: VirtualMiddleMileCarrier,
): string {
  return virtualMiddleMileCarrierNames[carrier];
}

/** Return Drop tracking event types (polled; Return Drop has no webhook). */
export const ReturnDropEventType = {
  LABEL_CREATED: "label_created",
  CUSTOMER_DROPOFF: "customer_dropoff",
  DELIVERED: "delivered",
} as const;
export type ReturnDropEventType =
  (typeof ReturnDropEventType)[keyof typeof ReturnDropEventType];
